<template >
    <Card>
      <AjaxForm route="admin/plan/add">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput label="عنوان" name="title" type="text" placeholder="عنوان را وارد کنید"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="select" name="type" select-label="title"
                         reduce_select="id"
                         v-model="type_plan"
                         :select-options="[{id : 'seller',title : 'عرضه کننده'},{id : 'buyer',title : 'خریدار'}]"
                         placeholder="نوع ارتباط را مشخص کنید" label="مرتبط به"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput select-label="title" reduce_select="id" type="select" name="is_enabled"
                         v-model="is_enabled"
                         :select-options="[{id : '1',title : 'فعال'},{id : '0',title : 'غیرفعال'}]"
                         placeholder="وضعیت را مشخص کنید" label="وضعیت"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput name="description" type="textarea" placeholder="توضیحات..." label="توضیحات"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <div class="form-group row">
              <div class="custom-control custom-switch switch-success">
                <input type="checkbox" name="is_proposed" value="1" class="custom-control-input" id="is_proposed">
                <label class="custom-control-label text-muted" for="is_proposed">اشتراک پیشنهادی می باشد</label>
              </div>
            </div>
            <div class="form-group row">
              <div class="custom-control custom-switch switch-success">
                <input type="checkbox" name="is_starter" value="1" class="custom-control-input" id="is_starter">
                <label class="custom-control-label text-muted" for="is_starter">دوره آزمایشی (یکبار قابل انتخاب)</label>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput name="color" type="color" label="رنگ اشتراک"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="number" name="sort" label="اولویت" placeholder="اولویت را وارد کنید"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4 d-flex mb-3">
            <label class="mr-3">تصویر</label>
            <ImagePicker name="pic_id"></ImagePicker>
          </div>
          <div class="col-12 col-sm-12 col-md-12">
            <button @click="addPriceItem()" class="btn btn-info btn-sm mb-2" type="button">افزودن قیمت&nbsp;<i class="far fa-plus"></i></button>
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead>
                <tr>
                  <th>عنوان</th>
                  <th>تعداد روز</th>
                  <th>تعداد سکه</th>
                  <th>قیمت</th>
                  <th>قیمت ویژه</th>
                  <th>حذف</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in prices" :key="prices">
                  <td><input type="text" name="item_titles[]" placeholder="عنوان..."
                             class="form-control form-control-sm" v-model="item.title"></td>
                  <td>
                    <NumberInput ClassName="form-control-sm" placeholder="تعداد روز..." name="n_days[]"
                                 v-model="item.n_day"></NumberInput>
                  </td>
                  <td>
                    <NumberInput ClassName="form-control-sm" placeholder="تعداد سکه..." name="n_coins[]"
                                 v-model="item.n_coin"></NumberInput>
                  </td>
                  <td>
                    <NumberInput ClassName="form-control-sm" placeholder="قیمت..." name="prices[]"
                                 v-model="item.price"></NumberInput>
                  </td>
                  <td>
                    <NumberInput ClassName="form-control-sm" placeholder="قیمت ویژه..." name="sp_price[]"
                                 v-model="item.sp_price"></NumberInput>
                    <CustomInput type="date"  name="sp_date[]" :date-time="true" v-model="item.sp_date" placeholder="تاریخ انقضا" without-label="true"></CustomInput>
                  </td>
                  <td><i class="fas fa-trash-can text-danger delete-btn" @click="deletePrice(index)"></i></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-10 col-sm-8 col-md-5 mx-auto">
            <button class="btn btn-info btn-block" type="submit">افزودن اشتراک</button>
          </div>
        </div>
      </AjaxForm>
    </Card>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import Card from "@/components/forms/Card";
import CustomInput from "@/components/CustomInput";
import ImagePicker from "@/components/ImagePicker";
import NumberInput from "@/components/NumberInput";
import AjaxForm from "@/components/forms/AjaxForm";
import {mapActions} from "vuex";
import Vue3PersianDatetimePicker  from 'vue3-persian-datetime-picker';
export default {
  name: "PlanAdd",
  components: {AjaxForm, NumberInput, ImagePicker, CustomInput, Card, MasterLayout,DatePicker: Vue3PersianDatetimePicker},
  data()
  {
    return{
      prices : [],
      type_plan : null,
      is_enabled:null,
    }
  },
  methods:{
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    addPriceItem(){
      this.prices.push({});
    },
    deletePrice(index)
    {
      this.prices.splice(index,1);
    }
  },
  async mounted()
  {
    this.setPageTitle('افزودن اشتراک');
    this.setShowHead(true);
  }
}
</script>

<style scoped>
.delete-btn
{
  cursor: pointer;
  padding: 5px;
  font-size: 18px;
}
</style>